import React from 'react';
import * as S from './styles';

interface Question {
  question: string;
  answer: React.ReactNode;
  answerType: string;
}

interface Facts {
  questions: Array<Question>;
}

interface AreaFactsProps {
  facts: Facts;
}

const AreaFacts: React.FC<AreaFactsProps> = ({ facts }) => {
  return (
    <S.AreaFacts>
      {facts.questions.map((question, idx) => (
        <S.AreaFactsSection key={`fact-section-question-${idx}-and-${question.answerType}`}>
          {question.question}
          {question.answer}
        </S.AreaFactsSection>
      ))}
    </S.AreaFacts>
  );
};

export default AreaFacts;
